import { render, staticRenderFns } from "./DetailsViewOld.vue?vue&type=template&id=b731ff00&scoped=true"
import script from "./DetailsViewOld.vue?vue&type=script&lang=js"
export * from "./DetailsViewOld.vue?vue&type=script&lang=js"
import style0 from "./DetailsViewOld.vue?vue&type=style&index=0&id=b731ff00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b731ff00",
  null
  
)

export default component.exports